import request from '../../components/api/api';
import {ROOT_URL} from '../../config';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {
    deletedPage,
    publishedPage,
    unpublishedPage,
    fetchedPage,
    fetchedPageTypes,
    fetchedPageTagsByPageType,
    clearTranslationSite,
    fetchedExistingPageTranslations,
    fetchedMissingPageTranslations,
    clearAddTranslationSites
} from './actions';

export function fetchPageTypes() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page-types`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedPageTypes(response.data)))
    }
}

export function fetchPage(id) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/pages/${id}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedPage(response)))
    }
}

export function deletePage(pageId, selectedStatus, redirectUrl) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page/${pageId}`,
            method: 'DELETE',
            data: {
                redirect_to_status: selectedStatus,
                redirect_to_url: redirectUrl
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(deletedPage(pageId)))
            .then((response) => dispatch(push(`/pages`)))
            .then(() => toastr.success('Success!', 'The page has been deleted.'))
    }
}

export function fetchPageTagsByPageType(pageTypeId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page-tags?page_type_id=${pageTypeId}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedPageTagsByPageType(response.data)))
    }
}

export function createPage(pageTypeId, selectedPageTags) {

    selectedPageTags = (selectedPageTags !== null && selectedPageTags instanceof Array) ? selectedPageTags : [selectedPageTags];

    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page`,
            method: 'POST',
            data: {
                page_type_id: pageTypeId,
                site_id: 0,
                tags: selectedPageTags
            }
        };
        return request(options, dispatch)
            .then((response) => setTimeout(() => dispatch(push(`/pages/` + response.data.page_id)), 1000))
            .then(() => toastr.success('Success!', 'The page has been created.'))
    }
}

export function publishPage(pageId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page/${pageId}/publish`,
            method: 'PUT',
        };

        return request(options, dispatch)
            .then(response => dispatch(publishedPage(pageId)))
            .then(() => toastr.success('Success!', 'The page has been published and is now visible on the website!'))
    }
}

export function unpublishPage(pageId, selectedStatus, redirectUrl) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page/${pageId}/unpublish`,
            method: 'PUT',
            data: {
                redirect_to_status: selectedStatus,
                redirect_to_url: redirectUrl
            }
        };

        return request(options, dispatch)
            .then(() => dispatch(unpublishedPage(pageId)))
            .then(() => toastr.success('Success!', 'The page has been unpublished and it is not visible on the website anymore!'))
    }
}

export function fetchExistingPageTranslations(pageId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page/${pageId}/translations`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedExistingPageTranslations(response.data)))
    }
}

export function createPageTranslation(pageId, siteId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page/${pageId}/translations`,
            method: 'POST',
            data: {
                site_id: siteId,
            }
        };
        return request(options, dispatch)
            .then((response) => setTimeout(() => dispatch(push(`/pages/` + response.data.page_id)), 1000))
            .then(() => toastr.success('Success!', 'The page translation has been created.'))
            .then(() => dispatch(clearTranslationSite()))
    }
}

export function createPageClones(pageId, siteIds) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/clone-page/${pageId}`,
            method: 'POST',
            data: {
                site_ids: siteIds,
            }
        };
        return request(options, dispatch)
            .then(() => toastr.success('Success!', 'The page translation(s) has been created.'))
            .then(() => dispatch(clearAddTranslationSites()))
            .then(() => dispatch(push(`/pages`)))
    }
}

export function fetchMissingPageTranslations(pageId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page/${pageId}/missing-translations`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedMissingPageTranslations(response.data)))
    }
}


// WEBPACK FOOTER //
// ./src/containers/pages/thunks.js